import { Pipe } from '@angular/core';
var IsGreaterPipe = (function () {
    function IsGreaterPipe() {
    }
    IsGreaterPipe.prototype.transform = function (first, second) {
        return first > second;
    };
    return IsGreaterPipe;
}());
export { IsGreaterPipe };
IsGreaterPipe.decorators = [
    { type: Pipe, args: [{
                name: 'greater'
            },] },
];
/** @nocollapse */
IsGreaterPipe.ctorParameters = function () { return []; };
var IsGreaterOrEqualPipe = (function () {
    function IsGreaterOrEqualPipe() {
    }
    IsGreaterOrEqualPipe.prototype.transform = function (first, second) {
        return first >= second;
    };
    return IsGreaterOrEqualPipe;
}());
export { IsGreaterOrEqualPipe };
IsGreaterOrEqualPipe.decorators = [
    { type: Pipe, args: [{
                name: 'greaterOrEqual'
            },] },
];
/** @nocollapse */
IsGreaterOrEqualPipe.ctorParameters = function () { return []; };
var IsLessPipe = (function () {
    function IsLessPipe() {
    }
    IsLessPipe.prototype.transform = function (first, second) {
        return first < second;
    };
    return IsLessPipe;
}());
export { IsLessPipe };
IsLessPipe.decorators = [
    { type: Pipe, args: [{
                name: 'less'
            },] },
];
/** @nocollapse */
IsLessPipe.ctorParameters = function () { return []; };
var IsLessOrEqualPipe = (function () {
    function IsLessOrEqualPipe() {
    }
    IsLessOrEqualPipe.prototype.transform = function (first, second) {
        return first <= second;
    };
    return IsLessOrEqualPipe;
}());
export { IsLessOrEqualPipe };
IsLessOrEqualPipe.decorators = [
    { type: Pipe, args: [{
                name: 'lessOrEqual'
            },] },
];
/** @nocollapse */
IsLessOrEqualPipe.ctorParameters = function () { return []; };
var IsEqualPipe = (function () {
    function IsEqualPipe() {
    }
    IsEqualPipe.prototype.transform = function (first, second) {
        return first == second;
    };
    return IsEqualPipe;
}());
export { IsEqualPipe };
IsEqualPipe.decorators = [
    { type: Pipe, args: [{
                name: 'equal'
            },] },
];
/** @nocollapse */
IsEqualPipe.ctorParameters = function () { return []; };
var IsNotEqualPipe = (function () {
    function IsNotEqualPipe() {
    }
    IsNotEqualPipe.prototype.transform = function (first, second) {
        return first != second;
    };
    return IsNotEqualPipe;
}());
export { IsNotEqualPipe };
IsNotEqualPipe.decorators = [
    { type: Pipe, args: [{
                name: 'notEqual'
            },] },
];
/** @nocollapse */
IsNotEqualPipe.ctorParameters = function () { return []; };
var IsIdenticalPipe = (function () {
    function IsIdenticalPipe() {
    }
    IsIdenticalPipe.prototype.transform = function (first, second) {
        return first === second;
    };
    return IsIdenticalPipe;
}());
export { IsIdenticalPipe };
IsIdenticalPipe.decorators = [
    { type: Pipe, args: [{
                name: 'identical'
            },] },
];
/** @nocollapse */
IsIdenticalPipe.ctorParameters = function () { return []; };
var IsNotIdenticalPipe = (function () {
    function IsNotIdenticalPipe() {
    }
    IsNotIdenticalPipe.prototype.transform = function (first, second) {
        return first !== second;
    };
    return IsNotIdenticalPipe;
}());
export { IsNotIdenticalPipe };
IsNotIdenticalPipe.decorators = [
    { type: Pipe, args: [{
                name: 'notIdentical'
            },] },
];
/** @nocollapse */
IsNotIdenticalPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=conditions.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/boolean/conditions.pipe.js
// module id = 256
// module chunks = 103